import { connect } from 'react-redux';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { compose } from 'ramda';
import { FORM_NAMES } from 'constants/forms';
import { NOT_APPLICABLE } from 'constants/common';
import DeviceInformationForm from 'components/DeviceInformation/DeviceInformationForm';
import validate from 'components/DeviceInformation/validate';

import {
  getReportItemPacingValue,
  getReportItemShockValue,
  getReportItemShockValueNa,
  getReportItemBatteryLife,
  getReportItemFormShocks,
  getReportItemAlert,
} from 'store/selectors/reports/singleItems';

import { reportsSubmitDeviceInfoForm } from 'store/actionCreators/reports/singleItems';

const selector = formValueSelector(FORM_NAMES.editDeviceStatus);

const mapStateToProps = (state, { reportId }) => ({
  initialValues: {
    alert: getReportItemAlert(reportId)(state),
    pacing: getReportItemPacingValue(reportId)(state),
    shock: getReportItemShockValue(reportId)(state),
    shockNa: getReportItemShockValueNa(reportId)(state),
    batteryLife: getReportItemBatteryLife(reportId)(state),
    shocksDate: getReportItemFormShocks(reportId)(state),
  },
  alert: selector(state, 'alert'),
  shockNa: selector(state, 'shockNa'),
});

const mapDispatchToProps = (dispatch, { reportId }) => ({
  onSubmit: () => dispatch(reportsSubmitDeviceInfoForm({ reportId })),
  onChangeShockCheckbox: (_, newValue) =>
    dispatch(change(FORM_NAMES.editDeviceStatus, 'shock', newValue ? NOT_APPLICABLE : '')),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  reduxForm({
    form: FORM_NAMES.editDeviceStatus,
    enableReinitialize: true,
    validate,
  }),
)(DeviceInformationForm);
